import { Dispatch, RefObject, SetStateAction, useCallback, useRef, useState } from "react"

const getValue = <T, S>(
    action: S | ((prev: T) => S),
    prev: T,
): S => {
    if (typeof action === 'function') {
        return (action as Function)(prev)
    } else {
        return action
    }
}

export function useStateRef<S>(
    initialState: S | (() => S),
): [S, RefObject<S>, Dispatch<SetStateAction<S>>] {
    const ref = useRef(getValue(initialState, undefined));
    const [state, _setState] = useState(initialState);

    const setState = useCallback<Dispatch<SetStateAction<S>>>((action) => {
        ref.current = getValue(action, ref.current);
        _setState(action);
    }, []);

    return [state, ref, setState];
}
